import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import LoginModal from '../LoginModal';
import SignupModal from '../SignupModal';
import ForgotModal from '../ForgotModal';
import GuestsModal from '../GuestsModal';
import StaffModal from '../StaffModal';
import CancelSubscriptionModal from '../CancelSubscriptionModal';
import SignUpForEmailAlertModal from '../../containers/SignUpForEmailAlertModal';
import CancelModal from '../../containers/CancelModal';
import CalendarModal from '../../containers/CalendarModal';
import ReviewModal from '../../containers/ReviewModal';
// import ActiveOfflineCampaignModal from "../ActiveOfflineCampaignModal"
// import ActiveCampaignModal from "../ActiveCampaignModal"

import HeroImage from '../../assets/img/lead-small.jpg';

const Layout = ({ children, heading, metaKeywords, openedModal, url, description, image, canonical, type }) => (
  <Fragment>
    <Head>
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content={type || 'website'} />
      <meta name="twitter:site" content="@dayaxeapp" />
      <meta name="twitter:creator" content="@dayaxeapp" />
      <meta property="fb:admins" content="100015428162611" />
      <meta property="og:site_name" content="Dayaxe.com" />
      {heading && (
        <Fragment>
          <title>{heading}</title>
          <meta property="og:title" content={heading} />
          <meta name="twitter:title" content={heading} />
          <meta itemProp="name" content={heading} />
        </Fragment>
      )}
      {url && (
        <Fragment>
          <meta property="og:url" content={url} />
          <meta name="twitter:url" content={url} />
        </Fragment>
      )}
      {description && (
        <Fragment>
          <meta name="description" content={description} />
          <meta itemProp="description" content={description} />
          <meta property="og:description" content={description} />
          <meta name="twitter:description" content={description} />
        </Fragment>
      )}
      <meta property="og:image" content={image || `https://dayaxe.com${HeroImage}`} />
      <meta name="twitter:image " content={image || `https://dayaxe.com${HeroImage}`} />
      <meta itemProp="image" content={image || `https://dayaxe.com${HeroImage}`} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:image:src" content={image || `https://dayaxe.com${HeroImage}`} />
      {metaKeywords && <meta name="keywords" content={metaKeywords} />}
    </Head>
    {children}
    {openedModal === 'validation' && <StaffModal />}
    {openedModal === 'signUpForEmailAlert' && <SignUpForEmailAlertModal />}
    {openedModal === 'cancelTicket' && <CancelModal />}
    {openedModal === 'calendar' && <CalendarModal />}
    {openedModal === 'review' && <ReviewModal />}
    {openedModal === 'addGuest' && <GuestsModal />}
    {openedModal === 'cancelSubscription' && <CancelSubscriptionModal />}
    <CSSTransition in={openedModal === 'login'} timeout={500} classNames="modal" unmountOnExit>
      <LoginModal name="login" />
    </CSSTransition>
    <CSSTransition in={openedModal === 'registration'} timeout={500} classNames="modal" unmountOnExit>
      <SignupModal name="registration" />
    </CSSTransition>
    <CSSTransition in={openedModal === 'forgot'} timeout={500} classNames="modal" unmountOnExit>
      <ForgotModal name="forgot" />
    </CSSTransition>
    <CSSTransition in={openedModal === 'forgot'} timeout={500} classNames="modal" unmountOnExit>
      <ForgotModal name="forgot" />
    </CSSTransition>
    {/* <CSSTransition in={openedModal === 'activeCampaign'} timeout={500} classNames="modal" unmountOnExit>
      <ActiveOfflineCampaignModal name="activeCampaign" />
    </CSSTransition> */}
    {/* <CSSTransition in={openedModal === 'activeCampaign'} timeout={500} classNames="modal" unmountOnExit>
      <ActiveCampaignModal name="activeCampaign" />
    </CSSTransition> */}
  </Fragment>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  heading: PropTypes.string.isRequired,
  openedModal: PropTypes.string,
  metaKeywords: PropTypes.string,
  url: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  canonical: PropTypes.string,
  type: PropTypes.string,
};

const mapStateToProps = state => ({
  openedModal: state.ui.openedModal,
});

export default connect(mapStateToProps)(Layout);
